export default function toDateTime(dateFilter, Authentication) {
  'ngInject';

  return function link(date) {
    const format = Authentication.user?.settings.usTimeFormat
      ? "MMM dd, yyyy 'at' h:mm a"
      : "dd MMM yyyy 'at' H:mm";
    return dateFilter(date, format);
  };
}
